import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lg:pl-6" }
const _hoisted_2 = {
  key: 0,
  class: "bg-primary-light-blue bg-opacity-60 border-l border-dark-blue border-opacity-10 w-full shadow-custom p-6 max-h-screen overflow-auto"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pb-6 w-full" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-sm font-bold uppercase text-blue-900" }, " Teadete logi ")
], -1)
const _hoisted_4 = { class: "flow-root" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardHomeNotificationsFeedListItem = _resolveComponent("DashboardHomeNotificationsFeedListItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.notifications.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification, i) => {
                return (_openBlock(), _createBlock(_component_DashboardHomeNotificationsFeedListItem, {
                  key: notification.uid,
                  notification: notification,
                  last: _ctx.notifications.length - 1 === i
                }, null, 8, ["notification", "last"]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}